import { motion } from 'framer-motion';
import { MapContainer } from '../components/Map/MapContainer';
import { Card } from '../components/common/Card';
import { RESOURCES } from '../data/resources';
import { GIS_SERVICE_CATEGORIES, GIS_SERVICES } from '../data/gisServices';

const pageMotion = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 }
};

export const MapExplorer = () => {
  const resourceCount = RESOURCES.length;
  const serviceCount = GIS_SERVICES.length;
  const categoryStats = GIS_SERVICE_CATEGORIES.map((category) => ({
    ...category,
    count: GIS_SERVICES.filter((service) => service.category === category.id).length
  }));

  return (
    <motion.div
      {...pageMotion}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="space-y-6"
    >
      <div className="container mx-auto px-4 pt-8">
        <div className="glass-panel p-6 md:p-8 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-cyan-300/28 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-pink-300/24 blur-3xl" />

          <div className="relative space-y-4">
            <div className="flex items-center justify-between flex-wrap gap-3">
              <h1 className="text-3xl md:text-4xl font-black text-gray-900">الخريطة التفاعلية للأطفال</h1>
              <div className="flex flex-wrap gap-2">
                <span className="chip">📍 موارد: <span className="number font-black">{resourceCount}</span></span>
                <span className="chip">🛰️ خدمات: <span className="number font-black">{serviceCount}</span></span>
                <span className="chip chip-strong">فلترة + بوب-أب + رسم + وضع أطفال</span>
              </div>
            </div>

            <p className="text-gray-700 max-w-3xl">
              اختار الأيقونات اللي بتحبها، فلتر الموارد والخدمات، واتحرك تلقائيًا لنتائجك. الخريطة هنا مصممة للتعلّم الممتع والبصري للأطفال.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {categoryStats.map((category) => (
                <Card key={category.id} className="p-4">
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-3">
                      <span className="text-2xl">{category.icon}</span>
                      <div>
                        <p className="font-black text-gray-900">{category.name}</p>
                        <p className="text-xs text-gray-600">{category.description}</p>
                      </div>
                    </div>
                    <div
                      className="w-10 h-10 rounded-2xl flex items-center justify-center text-white font-black shadow-lg"
                      style={{ backgroundColor: category.color }}
                    >
                      {category.count}
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>

      <MapContainer />
    </motion.div>
  );
};
